import { createFeatureSelector, createSelector } from '@ngrx/store'

import * as fromCart from './cart'
import * as fromRoot from '../../reducers'

import { CartStats } from '../models/cart-models';

export interface State extends fromRoot.State {
    cart: fromCart.State
}

export { reducer } from './cart'

export const getCartState = createFeatureSelector<fromCart.State>('cart')

export const getOrder = createSelector(
    getCartState,
    fromCart.getOrder
)
export const getProductIds = createSelector(
    getCartState,
    fromCart.getProductIds
)

export const getLineCount = createSelector(
    getCartState,
    fromCart.getLineCount
)
export const getProductCount = createSelector(
    getCartState,
    fromCart.getProductCount
)
export const getCurrency = createSelector(
    getCartState,
    fromCart.getCurrency
)
export const getTotalValue = createSelector(
    getCartState,
    fromCart.getTotalValue
)
export const getCartProducts = createSelector(
    getCartState,
    fromCart.getBusyProducts
)

export const getCartStats = createSelector(
    getLineCount,
    getTotalValue,
    getCurrency,
    (productCount, value, currency) => <CartStats>{
        productCount,
        currency,
        value
    }
)
export const getOrderId = createSelector(
    getOrder,
    order => order && order._id
)
export const getCurrentOrderLines = createSelector(
  getCartState,
  fromCart.getOrderLines
)
export const hasActiveCart = createSelector(
    getOrderId,
    orderId => !!orderId
)

export const getOrderExtraCosts = createSelector(
  getOrder,
  order => order && order.extraCosts
)
